import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var BUTTON_SIZES = Object.freeze({
  sm: T_SHIRT_SIZES.sm,
  md: T_SHIRT_SIZES.md,
  lg: T_SHIRT_SIZES.lg
});